import { wrapPromise } from 'persist-promise/wrapPromise';
import { getDefinitionsFromObjectTypeRpc } from '../__generated__/chirp/com/hubspot/association/definitions/rpc/AssociationDefinitionsRpc';
import { makeAssociationDefinitionsFetchKey } from './cacheKeys';
const fetchAssociationDefinitions = ({
  rpcClient,
  frameworkTypeIdentifier
}) => rpcClient.call(getDefinitionsFromObjectTypeRpc, {
  request: {
    objectType: frameworkTypeIdentifier,
    definitionRequestOptions: {
      enforceStrictPermissions: true
    }
  }
}).then(data => data.associationDefinitions);
export const associationDefinitionsPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'associationDefinitions',
  deepFreeze: true,
  toCacheKey: makeAssociationDefinitionsFetchKey,
  fetch: fetchAssociationDefinitions
});